import type { UseJobModulesCreateProps } from "./job-module.type";

import { useCreate } from "@/hooks/queries";

export const useJobModulesCreate = ({
  invalidateKeys,
}: UseJobModulesCreateProps) => {
  return useCreate("jobModules", {
    invalidateKeys,
  });
};
